var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryLowAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.83438H13.7032V6H1V13H13.7032V11.1509H15V7.83438ZM12.8125 12.0993H1.875V6.87133H12.8125V12.0993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34494 7.33496H2.35547V11.6494H4.34494V7.33496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0225 1.92308C10.0766 1.19639 10.1036 0.833045 10.4683 0.468343C10.833 0.103641 11.1964 0.0765995 11.9231 0.0225156C12.1115 0.00849564 12.3058 0 12.5001 0C12.6944 0 12.8887 0.00849579 13.0771 0.0225158C13.8038 0.0766 14.1672 0.103642 14.5319 0.468344C14.8966 0.833046 14.9236 1.19639 14.9777 1.92309C14.9917 2.11146 15.0002 2.30578 15.0002 2.5001C15.0002 2.69442 14.9917 2.88874 14.9777 3.07712C14.9236 3.80381 14.8966 4.16716 14.5319 4.53186C14.1672 4.89656 13.8038 4.9236 13.0771 4.97769C12.8887 4.99171 12.6944 5.0002 12.5001 5.0002C12.3058 5.0002 12.1115 4.99171 11.9231 4.97769C11.1964 4.9236 10.833 4.89656 10.4683 4.53186C10.1036 4.16716 10.0766 3.80381 10.0225 3.07712C10.0085 2.88874 10 2.69442 10 2.5001C10 2.30578 10.0085 2.11146 10.0225 1.92308Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4994 2.74179C12.6502 2.74179 12.7724 2.61767 12.7724 2.46456L12.7724 1.35633C12.7724 1.20322 12.6502 1.0791 12.4994 1.0791C12.3487 1.0791 12.2264 1.20322 12.2264 1.35633L12.2264 2.46456C12.2264 2.61767 12.3487 2.74179 12.4994 2.74179ZM12.84 3.57379C12.84 3.38258 12.6874 3.22757 12.4991 3.22757C12.3108 3.22757 12.1582 3.38258 12.1582 3.57379C12.1582 3.765 12.3108 3.92001 12.4991 3.92001C12.6874 3.92001 12.84 3.765 12.84 3.57379Z",
    fill: "#0097FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLowAlert);
export default __webpack_public_path__ + "static/media/batteryLowAlert.6247d0cb31eddde84597879b7645e9ff.svg";
export { ForwardRef as ReactComponent };